import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
    styles: {
        global: {
            body: {
                bg: 'linear-gradient(135deg, #000000 0%, #080820 40%, #0a2a6a 100%)', // Even darker gradient with a splash of blue
                fontFamily: 'Nunito, sans-serif', // Set Nunito as the font for body text
                color: "#ffffff",
                backgroundAttachment: "fixed", // Keeps the gradient static during scrolling
            },
        },
    },
    fonts: {
        body: 'system-ui, sans-serif', // Use the default sans-serif font for headers
        heading: 'Oswald, sans-serif', // Use the default sans-serif font for headings
    },
    components: {
        Text: {
            baseStyle: {
                maxW: '750px', // Set the maximum width for all Text components
                color: "#ffffff",
            },
        },
    },
});

export default theme;